import React, { useState } from "react";
import DeleteModalIcon from "../../../../assets/delete-modal-icon.svg";

function DeleteTransactionModal({ onClose, onConfirm, transaction }) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (!onConfirm) {
      onClose();
      return;
    }

    setIsDeleting(true);
    try {
      await onConfirm(transaction);
    } catch {
      // Error toast handled by parent
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="delete-transaction-backdrop" onClick={isDeleting ? undefined : onClose}>
      <div
        className="delete-transaction-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="delete-transaction-icon-circle">
          <img src={DeleteModalIcon} alt="Delete" />
        </div>

        <h3 className="delete-transaction-title">Delete Transaction</h3>
        <p className="delete-transaction-description">
          Are you sure you want to delete this transaction? This action will
          soft-delete the record and can be recovered by administrators.
        </p>

        <div className="delete-transaction-actions">
          <button
            type="button"
            className="delete-transaction-btn-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-transaction-btn-confirm"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteTransactionModal;
